import React, { useRef } from "react";
import { Grid } from "antd";
import Icon from '@ant-design/icons';
import _ from 'lodash';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useSelector } from "react-redux";
import Marquee from "react-fast-marquee";

const { useBreakpoint } = Grid;

const responsive = {
  desktop_xl: {
    breakpoint: { max: 3000, min: 1800 },
    items: 5,
    slidesToSlide: 1,
    partialVisibilityGutter: 20
  },
  desktop: {
    breakpoint: { max: 1800, min: 1200 },
    items: 5,
    slidesToSlide: 1,
    partialVisibilityGutter: 20
  },
  tablet: {
    breakpoint: { max: 1200, min: 896 },
    items: 3,
    slidesToSlide: 1,
    partialVisibilityGutter: 20
  },
  mobile: {
    breakpoint: { max: 896, min: 0 },
    items: 2,
    slidesToSlide: 1,
    partialVisibilityGutter: 20
  },
};


const ImageCarousel = (props) => {
  const { data } = props;
  const config = useSelector(state => state.app.client.config)
  const carouselNewItem = useRef();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <Marquee {...props.options}>
      {_.map(data, (item, index) => {
        return (
          <img key={index} draggable={false} alt="cover_image" src={`${item}`} style={{ objectFit: 'cover', margin: isMobile ? '0px 20px' : '0px 30px 0 0', width: isMobile ? '100%' : '100%', maxWidth: isMobile ? 160 : 260, borderRadius: 8 }} />
        );
      })}
    </Marquee>
  )

  // return (
  //   <Carousel
  //     ref={carouselNewItem}
  //     responsive={responsive}
  //     shouldResetAutoplay={false}
  //     infinite
  //     keyBoardControl
  //     autoPlay
  //     showDots={false}
  //     arrows={false}
  //     renderDotsOutside={false}
  //     dotListClass="image-dot-list"
  //     customTransition="transform 500ms ease-in-out"
  //     partialVisible={!isMobile}

  //   // centerMode
  //   >
  //     {_.map(data, (item, index) => {
  //       return (
  //         <img key={index} draggable={false} alt="cover_image" src={`${item}`} style={{ objectFit: 'cover', margin: isMobile ? '0px 20px' : '0px 30px 0 0', width: isMobile ? '80%' : '80%' }} />
  //       );
  //     })}
  //   </Carousel>
  // )
}

export default ImageCarousel;
